module.exports = __webpack_public_path__ + "img/1.bc2e87e.webp";